module.exports = __webpack_public_path__ + "img/autospin_btn.8e02f4a2.png";